import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { TypeAheadDTO } from "~app/common/models/common/TypeAheadDTO";
import { AnvandareService } from "~app/common/services/anvandare.service";
import { SearchComponent } from "../../search/search.component";
import { DashboardService, DashboardUser } from "../dashboard.service";

@Component({
    selector: "rask-dashboard-admin",
    imports: [SearchComponent],
    templateUrl: "./dashboard-admin.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./dashboard-admin.component.scss"
})
export class DashboardAdminComponent {
    private readonly anvandareService = inject(AnvandareService);
    private readonly dashboardService = inject(DashboardService);

    protected searchAnvandareTypeAhead = (searchString: string) => this.anvandareService.searchForAnvandareTypeahead(searchString);

    protected searchAnvandareTypeAheadChange(value: TypeAheadDTO): void {
        const user: DashboardUser = value !== null ? {
            displayName: value.namn,
            username: value.kod,
            id: value.id
        } : null;
        this.dashboardService.setUser(user);
    }
}
